import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Advantages = () => {
  const sectionRef = useRef(null);
  const lineRef = useRef(null);
  const line2Ref = useRef(null);
  const line3Ref = useRef(null);

  useEffect(() => {
    // Animation pour les lignes horizontales
    const lines = [lineRef.current, line2Ref.current, line3Ref.current];
    
    lines.forEach(line => {
      if (line) {
        gsap.to(line, {
          width: '100%',
          duration: 1.5,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: line,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        });
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <>
      {/* Section Why */}
      <section className="section_why" ref={sectionRef}>
        <div className="padding-global">
          <div className="container-large">
            <div data-horizontal-line-anim="true" className="horizontal-line" ref={lineRef} style={{ width: '0%' }}></div>
            <div className="spacer-1-5 spacer-mobile-1"></div>
            <div className="grid _2-desk-1-mobile">
              <div className="grid-block">
                <h2>Why invest in a SOL treasury company?</h2>
              </div>
              <div className="grid-block">
                <div className="heading-style-h4">
                  <p>A Solana treasury company isn't a replacement for owning Solana. It's a capital structure on top of Solana, designed to attract misallocated fiat and turn it into SOL faster than you can do alone.</p>
                </div>
              </div>
            </div>
            <div className="spacer-10 spacer-mobile-4-5"></div>
            <div className="grid _2-desk-1-mobile">
              <div className="grid-block">
                <div className="why-solana-grid-block">
                  <div className="why-sol-icon">
                    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_4068_983)">
                        <path
                          d="M33 47.04C25.4385 47.04 19.2555 41.031 18.9705 33.54H13.5C13.2015 33.54 12.96 33.2985 12.96 33V13.5C12.96 13.2015 13.2015 12.96 13.5 12.96H21C21.144 12.96 21.2805 13.017 21.381 13.1175C21.483 13.2195 21.54 13.356 21.54 13.5V24.8925C22.47 23.571 23.6295 22.416 24.96 21.4935V1.4985C24.96 1.2 25.2015 0.958496 25.5 0.958496H33C33.144 0.958496 33.282 1.0155 33.3825 1.116C33.483 1.2195 33.54 1.3575 33.54 1.5L33.5385 18.9705C41.031 19.254 47.04 25.4385 47.04 33C47.04 40.7415 40.7415 47.04 33 47.04ZM33 20.04C30.4215 20.04 27.933 20.796 25.8 22.2285C23.97 23.4405 22.4775 25.1175 21.4815 27.081C20.538 28.8945 20.04 30.9405 20.04 33C20.04 40.146 25.854 45.96 33 45.96C40.146 45.96 45.96 40.146 45.96 33C45.96 25.854 40.146 20.04 33 20.04ZM14.04 32.46H18.9705C19.0485 30.4575 19.5585 28.482 20.46 26.7075V14.04H14.04V32.46ZM26.04 2.04L26.0385 20.8095C26.166 20.7375 26.2935 20.6655 26.424 20.5965C27.3465 20.1045 28.3185 19.7205 29.3235 19.4475C30.342 19.1715 31.392 19.011 32.4585 18.9705L32.46 2.04H26.04ZM33.54 40.5H32.46V38.04H28.5V36.96H35.25C36.1935 36.96 36.96 36.1935 36.96 35.25C36.96 34.3065 36.1935 33.54 35.25 33.54H30.7485C29.211 33.54 27.96 32.2875 27.96 30.75C27.96 29.2125 29.211 27.96 30.7485 27.96H32.46V25.5H33.5415V27.96H37.5V29.0415H30.7485C29.8065 29.0415 29.04 29.808 29.04 30.7515C29.04 31.695 29.8065 32.4615 30.7485 32.4615H35.25C36.7875 32.4615 38.04 33.714 38.04 35.2515C38.04 36.789 36.7875 38.0415 35.25 38.0415H33.54V40.5ZM8.99996 33.54H1.49996C1.20146 33.54 0.959961 33.2985 0.959961 33V22.5C0.959961 22.2015 1.20146 21.96 1.49996 21.96H8.99996C9.29846 21.96 9.53996 22.2015 9.53996 22.5V33C9.53996 33.2985 9.29846 33.54 8.99996 33.54ZM2.03996 32.46H8.45996V23.04H2.03996V32.46Z"
                          fill="#FAFAFA"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_4068_983">
                          <rect width="48" height="48" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="why-sol-text_wrapper">
                    <div className="heading-style-h2">
                      <p>Lower Cost</p>
                    </div>
                    <p>Ability to buy locked solana at a discount</p>
                  </div>
                </div>
                <div className="horizontal-line is-dashed"></div>
              </div>
              <div className="grid-block">
                <div className="why-solana-grid-block">
                  <div className="why-sol-icon">
                    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_4068_986)">
                        <path
                          d="M25.8056 24.5446C26.7806 24.5446 28.0211 24.2581 29.1401 23.1391C31.3796 20.8996 30.2816 18.1726 30.2336 18.0586C30.1796 17.9266 30.0761 17.8216 29.9441 17.7676C29.8271 17.7211 27.1001 16.6201 24.8621 18.8611C24.4721 19.2511 24.2126 19.6546 24.0011 20.0566C23.7911 19.6546 23.5301 19.2511 23.1401 18.8611C20.9006 16.6216 18.1721 17.7211 18.0596 17.7676C17.9276 17.8231 17.8226 17.9266 17.7686 18.0586C17.7206 18.1741 16.6226 20.8996 18.8621 23.1391C19.9811 24.2581 21.2201 24.5446 22.1951 24.5446C22.7156 24.5446 23.1506 24.4636 23.4611 24.3841V44.4601H9.53962V37.8856C9.85012 37.9651 10.2851 38.0461 10.8041 38.0461C11.7791 38.0461 13.0211 37.7596 14.1386 36.6406C16.3781 34.4011 15.2801 31.6726 15.2321 31.5571C15.1766 31.4251 15.0731 31.3216 14.9411 31.2676C14.8271 31.2181 12.0986 30.1216 9.86062 32.3611C9.47062 32.7496 9.20962 33.1531 8.99962 33.5566C8.78962 33.1531 8.52862 32.7496 8.13862 32.3611C5.90062 30.1231 3.17212 31.2181 3.05812 31.2676C2.92612 31.3216 2.82112 31.4251 2.76712 31.5571C2.71912 31.6726 1.62112 34.4011 3.86062 36.6406C4.97962 37.7581 6.22012 38.0461 7.19512 38.0461C7.71412 38.0461 8.14912 37.9651 8.45962 37.8856V44.4601H4.49962V45.5416H28.4996V44.4601H24.5396V34.7251L27.3821 31.8826L26.6171 31.1176L24.5396 33.1966V24.3841C24.8501 24.4636 25.2851 24.5446 25.8056 24.5446ZM8.30962 36.8086C7.71712 36.9751 6.03562 37.2856 4.62412 35.8756C3.20812 34.4611 3.51862 32.7871 3.69112 32.1916C4.28362 32.0251 5.96512 31.7146 7.37662 33.1246C8.22862 33.9766 8.45062 34.9171 8.45962 35.6656C8.45962 35.7061 8.46112 35.7421 8.46262 35.7811C8.45362 36.2236 8.37262 36.5896 8.30962 36.8086ZM9.54112 35.6656C9.54862 34.9186 9.77212 33.9766 10.6241 33.1246C12.0416 31.7071 13.7156 32.0206 14.3096 32.1901C14.4836 32.7841 14.7941 34.4596 13.3766 35.8756C11.9591 37.2931 10.2851 36.9796 9.69112 36.8101C9.62662 36.5911 9.54562 36.2251 9.53812 35.7811C9.53812 35.7421 9.54112 35.7061 9.54112 35.6656ZM24.5411 22.1656C24.5486 21.4186 24.7721 20.4766 25.6241 19.6246C27.0386 18.2086 28.7156 18.5206 29.3081 18.6916C29.4761 19.2826 29.7851 20.9671 28.3751 22.3771C26.9591 23.7931 25.2836 23.4841 24.6911 23.3101C24.6266 23.0911 24.5456 22.7266 24.5381 22.2826C24.5381 22.2406 24.5411 22.2061 24.5411 22.1656ZM19.6241 22.3756C18.2081 20.9581 18.5186 19.2841 18.6911 18.6901C19.2851 18.5161 20.9591 18.2056 22.3766 19.6231C23.2286 20.4751 23.4506 21.4171 23.4596 22.1641C23.4596 22.2046 23.4626 22.2406 23.4626 22.2796C23.4551 22.7236 23.3726 23.0896 23.3096 23.3071C22.7156 23.4826 21.0401 23.7931 19.6241 22.3756ZM40.8056 11.0446C41.7806 11.0446 43.0211 10.7581 44.1401 9.63911C46.3796 7.39961 45.2816 4.67261 45.2336 4.55861C45.1796 4.42661 45.0761 4.32161 44.9441 4.26761C44.8256 4.22111 42.1001 3.12011 39.8606 5.36111C39.4706 5.74961 39.2096 6.15311 38.9996 6.55511C38.7896 6.15311 38.5286 5.74961 38.1401 5.36111C35.8976 3.12011 33.1721 4.22111 33.0566 4.26761C32.9246 4.32311 32.8211 4.42661 32.7671 4.55861C32.7191 4.67411 31.6196 7.40111 33.8606 9.63911C34.9796 10.7581 36.2186 11.0446 37.1951 11.0446C37.7156 11.0446 38.1491 10.9636 38.4611 10.8841V27.1951L36.3836 25.1191L35.6186 25.8826L38.4611 28.7251V44.4601H34.4996V45.5416H43.4996V44.4601H39.5396V21.2236L42.3821 18.3811L41.6171 17.6176L39.5396 19.6951V10.8841C39.8516 10.9636 40.2866 11.0446 40.8056 11.0446ZM39.5441 8.69111C39.5486 7.93811 39.7661 6.98111 40.6241 6.12311C42.0401 4.70711 43.7171 5.01911 44.3081 5.19011C44.4761 5.78111 44.7851 7.46561 43.3751 8.87561C41.9606 10.2916 40.2851 9.98111 39.6911 9.80861C39.6281 9.58661 39.5441 9.21011 39.5411 8.75111C39.5411 8.73011 39.5441 8.71361 39.5441 8.69111ZM34.6241 8.87561C33.2066 7.45811 33.5171 5.78411 33.6896 5.19011C34.2866 5.01761 35.9591 4.70561 37.3751 6.12311C38.2241 6.97061 38.4476 7.90661 38.4581 8.65211C38.4581 8.70011 38.4596 8.74361 38.4611 8.79161C38.4521 9.22961 38.3726 9.59111 38.3096 9.80861C37.7156 9.98261 36.0416 10.2946 34.6241 8.87561Z"
                          fill="#FAFAFA"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_4068_986">
                          <rect width="48" height="48" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="why-sol-text_wrapper">
                    <div className="heading-style-h2">
                      <p>Better Yield</p>
                    </div>
                    <p>Ability to acquire validators to increase returns</p>
                  </div>
                </div>
                <div className="horizontal-line is-dashed"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Section Advantages */}
      <section className="section_advantages">
        <div className="padding-global">
          <div className="container-large">
            <div data-horizontal-line-anim="true" className="horizontal-line" ref={line2Ref} style={{ width: '0%' }}></div>
            <div className="w-layout-grid grid _2-desk-1-mobile">
              <div className="grid-block">
                <div className="spacer-1-5 spacer-mobile-1"></div>
                <h1 className="heading-style-h2">Our advantages</h1>
              </div>
              <div className="advantages_wrapper">
                <div className="advantage-comp-line_wrapper">
                  <div className="advantage_component">
                    <div className="advantage-icon w-embed">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.75001 10.5C6.00833 10.5 5.2833 10.2801 4.66662 9.86801C4.04993 9.45596 3.56929 8.87029 3.28546 8.18506C3.00163 7.49984 2.92737 6.74584 3.07206 6.01841C3.21676 5.29098 3.57391 4.6228 4.09836 4.09835C4.6228 3.5739 5.29099 3.21675 6.01842 3.07206C6.74585 2.92736 7.49985 3.00162 8.18507 3.28545C8.87029 3.56928 9.45596 4.04993 9.86802 4.66661C10.2801 5.2833 10.5 6.00832 10.5 6.75C10.4989 7.74423 10.1035 8.69742 9.40045 9.40045C8.69743 10.1035 7.74423 10.4989 6.75001 10.5ZM6.75001 4.5C6.305 4.5 5.86998 4.63196 5.49997 4.8792C5.12996 5.12643 4.84158 5.47783 4.67128 5.88896C4.50098 6.3001 4.45642 6.7525 4.54324 7.18896C4.63006 7.62541 4.84435 8.02632 5.15902 8.34099C5.47368 8.65566 5.8746 8.86995 6.31105 8.95677C6.74751 9.04359 7.19991 8.99903 7.61104 8.82873C8.02218 8.65843 8.37358 8.37005 8.62081 8.00004C8.86805 7.63002 9.00001 7.19501 9.00001 6.75C8.99935 6.15347 8.76209 5.58155 8.34027 5.15973C7.91846 4.73792 7.34654 4.50066 6.75001 4.5Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M19.9394 3.00004L3 19.9395L4.06055 21L21 4.06059L19.9394 3.00004Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M17.25 21C16.5083 21 15.7833 20.7801 15.1666 20.368C14.5499 19.956 14.0693 19.3703 13.7855 18.6851C13.5016 17.9998 13.4274 17.2458 13.5721 16.5184C13.7168 15.791 14.0739 15.1228 14.5984 14.5984C15.1228 14.0739 15.791 13.7168 16.5184 13.5721C17.2458 13.4274 17.9998 13.5016 18.6851 13.7855C19.3703 14.0693 19.956 14.5499 20.368 15.1666C20.7801 15.7833 21 16.5083 21 17.25C20.9989 18.2442 20.6035 19.1974 19.9004 19.9004C19.1974 20.6035 18.2442 20.9989 17.25 21ZM17.25 15C16.805 15 16.37 15.132 16 15.3792C15.63 15.6264 15.3416 15.9778 15.1713 16.389C15.001 16.8001 14.9564 17.2525 15.0432 17.689C15.1301 18.1254 15.3443 18.5263 15.659 18.841C15.9737 19.1557 16.3746 19.37 16.8111 19.4568C17.2475 19.5436 17.6999 19.499 18.111 19.3287C18.5222 19.1584 18.8736 18.87 19.1208 18.5C19.368 18.13 19.5 17.695 19.5 17.25C19.4994 16.6535 19.2621 16.0816 18.8403 15.6597C18.4185 15.2379 17.8465 15.0007 17.25 15Z"
                          fill="#A0A0B2"
                        ></path>
                      </svg>
                    </div>
                    <div className="heading-style-h4">
                      <div>Access to locked SOL at discount</div>
                    </div>
                  </div>
                  <div className="horizontal-line is-dashed"></div>
                </div>
                <div className="advantage-comp-line_wrapper">
                  <div className="advantage_component">
                    <div className="advantage-icon w-embed">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7.5 6H6V9H7.5V6Z" fill="#A0A0B2"></path>
                        <path
                          d="M7.5 10.5H6V13.5H7.5V10.5Z"
                          fill="#A0A0B2"
                        ></path>
                        <path d="M12 6H10.5V9H12V6Z" fill="#A0A0B2"></path>
                        <path
                          d="M12 10.5H10.5V13.5H12V10.5Z"
                          fill="#A0A0B2"
                        ></path>
                        <path d="M7.5 15H6V18H7.5V15Z" fill="#A0A0B2"></path>
                        <path d="M12 15H10.5V18H12V15Z" fill="#A0A0B2"></path>
                        <path
                          d="M22.5 10.5C22.5 10.1022 22.342 9.72064 22.0607 9.43934C21.7794 9.15804 21.3978 9 21 9H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V22.5H22.5V10.5ZM3 3H15V21H3V3ZM16.5 21V10.5H21V21H16.5Z"
                          fill="#A0A0B2"
                        ></path>
                      </svg>
                    </div>
                    <div className="heading-style-h4">
                      <div>In-house staking</div>
                    </div>
                  </div>
                  <div className="horizontal-line is-dashed"></div>
                </div>
                <div className="advantage-comp-line_wrapper">
                  <div className="advantage_component">
                    <div className="advantage-icon w-embed">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.25 15H6.75C6.15326 15 5.58097 15.2371 5.15901 15.659C4.73705 16.081 4.5 16.6533 4.5 17.25V18.75H6V17.25C6 17.0511 6.07902 16.8603 6.21967 16.7197C6.36032 16.579 6.55109 16.5 6.75 16.5H11.25C11.4489 16.5 11.6397 16.579 11.7803 16.7197C11.921 16.8603 12 17.0511 12 17.25V18.75H13.5V17.25C13.5 16.6533 13.2629 16.081 12.841 15.659C12.419 15.2371 11.8467 15 11.25 15Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M9 14.25C9.59334 14.25 10.1734 14.0741 10.6667 13.7444C11.1601 13.4148 11.5446 12.9462 11.7716 12.3981C11.9987 11.8499 12.0581 11.2467 11.9424 10.6647C11.8266 10.0828 11.5409 9.54824 11.1213 9.12868C10.7018 8.70912 10.1672 8.4234 9.58527 8.30764C9.00333 8.19189 8.40013 8.2513 7.85195 8.47836C7.30377 8.70542 6.83524 9.08994 6.50559 9.58329C6.17595 10.0766 6 10.6567 6 11.25C6 12.0456 6.31607 12.8087 6.87868 13.3713C7.44129 13.9339 8.20435 14.25 9 14.25ZM9 9.75C9.29667 9.75 9.58668 9.83797 9.83335 10.0028C10.08 10.1676 10.2723 10.4019 10.3858 10.676C10.4994 10.9501 10.5291 11.2517 10.4712 11.5426C10.4133 11.8336 10.2704 12.1009 10.0607 12.3107C9.85088 12.5204 9.58361 12.6633 9.29264 12.7212C9.00166 12.7791 8.70006 12.7494 8.42597 12.6358C8.15189 12.5223 7.91762 12.33 7.7528 12.0834C7.58797 11.8367 7.5 11.5467 7.5 11.25C7.5 10.8522 7.65804 10.4706 7.93934 10.1893C8.22064 9.90804 8.60218 9.75 9 9.75Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M21 14.25V21H3V6H12V4.5H3C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V14.25H21Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M19.5 14.25H15V15.75H19.5V14.25Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M19.5 17.25H16.5V18.75H19.5V17.25Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M24 7.5V6H22.4242C22.3275 5.53055 22.1411 5.08416 21.8752 4.68532L22.9928 3.56783L21.9323 2.50733L20.8148 3.62483C20.4159 3.35895 19.9695 3.17255 19.5 3.07582V1.5H18V3.07582C17.5305 3.17253 17.0842 3.35892 16.6853 3.62475L15.5678 2.50725L14.5073 3.56775L15.6248 4.68525C15.359 5.0841 15.1725 5.53051 15.0758 6H13.5V7.5H15.0758C15.1725 7.96945 15.3589 8.41584 15.6248 8.81468L14.5072 9.93217L15.5677 10.9927L16.6852 9.87517C17.0841 10.141 17.5305 10.3275 18 10.4242V12H19.5V10.4242C19.9695 10.3275 20.4158 10.1411 20.8147 9.87525L21.9322 10.9928L22.9927 9.93225L21.8752 8.81475C22.141 8.4159 22.3275 7.96949 22.4242 7.5H24ZM18.75 9C18.305 9 17.87 8.86804 17.5 8.62081C17.13 8.37357 16.8416 8.02217 16.6713 7.61104C16.501 7.1999 16.4564 6.7475 16.5432 6.31105C16.63 5.87459 16.8443 5.47368 17.159 5.15901C17.4737 4.84434 17.8746 4.63005 18.311 4.54323C18.7475 4.45642 19.1999 4.50097 19.611 4.67127C20.0222 4.84157 20.3736 5.12996 20.6208 5.49997C20.868 5.86998 21 6.30499 21 6.75C20.9993 7.34654 20.7621 7.91845 20.3403 8.34027C19.9185 8.76208 19.3465 8.99934 18.75 9Z"
                          fill="#A0A0B2"
                        ></path>
                      </svg>
                    </div>
                    <div className="heading-style-h4">
                      <div>Validator management</div>
                    </div>
                  </div>
                  <div className="horizontal-line is-dashed"></div>
                </div>
                <div className="advantage-comp-line_wrapper">
                  <div className="advantage_component">
                    <div className="advantage-icon w-embed">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.4995 13.5C18.8362 13.5019 18.1923 13.7239 17.6686 14.131C17.145 14.5382 16.7713 15.1076 16.606 15.75H13.4995C12.903 15.7494 12.3311 15.5121 11.9093 15.0903C11.4874 14.6685 11.2502 14.0965 11.2495 13.5V10.5C11.2467 9.68597 10.9764 8.89543 10.4803 8.25001H16.606C16.7886 8.957 17.2227 9.57315 17.827 9.98296C18.4314 10.3928 19.1644 10.5681 19.8888 10.4761C20.6131 10.3841 21.2791 10.0311 21.7618 9.48318C22.2445 8.9353 22.5108 8.23019 22.5108 7.50001C22.5108 6.76983 22.2445 6.06471 21.7618 5.51683C21.2791 4.96895 20.6131 4.61592 19.8888 4.52392C19.1644 4.43191 18.4314 4.60725 17.827 5.01706C17.2227 5.42687 16.7886 6.04301 16.606 6.75001H7.39302C7.21047 6.04301 6.77635 5.42687 6.17201 5.01706C5.56768 4.60725 4.83463 4.43191 4.11027 4.52392C3.38591 4.61592 2.71997 4.96895 2.23728 5.51683C1.75459 6.06471 1.48828 6.76983 1.48828 7.50001C1.48828 8.23019 1.75459 8.9353 2.23728 9.48318C2.71997 10.0311 3.38591 10.3841 4.11027 10.4761C4.83463 10.5681 5.56768 10.3928 6.17201 9.98296C6.77635 9.57315 7.21047 8.957 7.39302 8.25001H7.49952C8.09606 8.25066 8.66797 8.48793 9.08979 8.90974C9.5116 9.33156 9.74886 9.90347 9.74952 10.5V13.5C9.75069 14.4942 10.1462 15.4474 10.8492 16.1504C11.5522 16.8534 12.5053 17.2488 13.4995 17.25H16.606C16.7472 17.7921 17.0375 18.2837 17.4441 18.669C17.8506 19.0543 18.3571 19.3179 18.9059 19.4298C19.4547 19.5418 20.024 19.4976 20.5489 19.3022C21.0739 19.1069 21.5336 18.7683 21.8757 18.3248C22.2179 17.8814 22.4289 17.3508 22.4847 16.7935C22.5405 16.2361 22.4389 15.6743 22.1914 15.1718C21.9439 14.6693 21.5605 14.2463 21.0846 13.9508C20.6088 13.6552 20.0597 13.4991 19.4995 13.5ZM19.4995 6.00001C19.7962 6.00001 20.0862 6.08798 20.3329 6.2528C20.5795 6.41762 20.7718 6.65189 20.8853 6.92598C20.9989 7.20007 21.0286 7.50167 20.9707 7.79264C20.9128 8.08361 20.77 8.35089 20.5602 8.56067C20.3504 8.77045 20.0831 8.91331 19.7922 8.97119C19.5012 9.02906 19.1996 8.99936 18.9255 8.88583C18.6514 8.77229 18.4171 8.58004 18.2523 8.33336C18.0875 8.08669 17.9995 7.79668 17.9995 7.50001C18 7.10232 18.1582 6.72106 18.4394 6.43985C18.7206 6.15865 19.1018 6.00046 19.4995 6.00001ZM4.49952 9.00001C4.20285 9.00001 3.91284 8.91203 3.66616 8.74721C3.41949 8.58239 3.22723 8.34812 3.1137 8.07403C3.00017 7.79994 2.97046 7.49834 3.02834 7.20737C3.08622 6.9164 3.22908 6.64913 3.43886 6.43935C3.64864 6.22957 3.91591 6.08671 4.20688 6.02883C4.49785 5.97095 4.79945 6.00066 5.07354 6.11419C5.34763 6.22772 5.5819 6.41998 5.74672 6.66665C5.91154 6.91333 5.99952 7.20334 5.99952 7.50001C5.99912 7.89771 5.84096 8.27901 5.55974 8.56023C5.27852 8.84145 4.89722 8.99961 4.49952 9.00001ZM19.4995 18C19.2028 18 18.9128 17.912 18.6662 17.7472C18.4195 17.5824 18.2272 17.3481 18.1137 17.074C18.0002 16.7999 17.9705 16.4983 18.0283 16.2074C18.0862 15.9164 18.2291 15.6491 18.4389 15.4393C18.6486 15.2296 18.9159 15.0867 19.2069 15.0288C19.4979 14.971 19.7995 15.0007 20.0735 15.1142C20.3476 15.2277 20.5819 15.42 20.7467 15.6667C20.9115 15.9133 20.9995 16.2033 20.9995 16.5C20.999 16.8977 20.8408 17.2789 20.5596 17.5601C20.2784 17.8413 19.8972 17.9995 19.4995 18Z"
                          fill="#A0A0B2"
                        ></path>
                      </svg>
                    </div>
                    <div className="heading-style-h4">
                      <div>Yield from DeFi &amp; options</div>
                    </div>
                  </div>
                  <div className="horizontal-line is-dashed"></div>
                </div>
                <div className="advantage-comp-line_wrapper">
                  <div className="advantage_component">
                    <div className="advantage-icon w-embed">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.5 21.0002H1.5V22.5002H22.5V21.0002Z"
                          fill="#A0A0B2"
                        ></path>
                        <path
                          d="M20.25 8.25017C20.4489 8.25017 20.6397 8.17115 20.7803 8.0305C20.921 7.88985 21 7.69908 21 7.50017V5.25017C20.9999 5.09603 20.9524 4.94566 20.8638 4.81952C20.7752 4.69337 20.65 4.59757 20.505 4.54517L12.255 1.54517C12.0902 1.48559 11.9098 1.48559 11.745 1.54517L3.495 4.54517C3.35005 4.59757 3.22476 4.69337 3.13619 4.81952C3.04762 4.94566 3.00007 5.09603 3 5.25017V7.50017C3 7.69908 3.07902 7.88985 3.21967 8.0305C3.36032 8.17115 3.55109 8.25017 3.75 8.25017H4.5V18.0002H3V19.5002H21V18.0002H19.5V8.25017H20.25ZM4.5 5.77517L12 3.04517L19.5 5.77517V6.75017H4.5V5.77517ZM13.5 18.0002H10.5V8.25017H13.5V18.0002ZM6 8.25017H9V18.0002H6V8.25017ZM18 18.0002H15V8.25017H18V18.0002Z"
                          fill="#A0A0B2"
                        ></path>
                      </svg>
                    </div>
                    <div className="heading-style-h4">
                      <div>Capital Markets Access</div>
                    </div>
                  </div>
                  <div className="horizontal-line is-dashed"></div>
                </div>
              </div>
            </div>
            <div className="spacer-5"></div>
            <div data-horizontal-line-anim="true" className="horizontal-line" ref={line3Ref} style={{ width: '0%' }}></div>
            <div className="spacer-1-5"></div>
            <div className="w-layout-grid grid _2-desk-1-mobile">
              <div className="grid-block">
                <h1 className="heading-style-h2">Value for Shareholders</h1>
              </div>
              <div className="grid-block">
                <div className="heading-style-h4">
                  <p>
                    With proven scalability, low costs, and a thriving
                    ecosystem, Solana is a leading contender for institutional
                    and retail adoption, delivering transformative
                    opportunities for investors.
                  </p>
                </div>
              </div>
            </div>
            <div className="spacer-5 spacer-mobile-4"></div>
            <div className="value_wrapper">
              <div
                id="w-node-fb5d98e8-3d59-4c34-bcf5-958f2100de0a-41beb241"
                className="value-component"
              >
                <div className="heading-style-h4">
                  <div className="text-weight-semibold">
                    <div>Easy Access</div>
                  </div>
                </div>
                <div className="max-width-39-36">
                  <p>
                    Seamless investment access to Solana with
                    institutional-grade custody
                  </p>
                </div>
              </div>
              <div
                id="w-node-_52873b51-beb9-7908-a21d-99d082355864-41beb241"
                className="value-component"
              >
                <div className="heading-style-h4">
                  <div className="text-weight-semibold">
                    <div>Staking Yield</div>
                  </div>
                </div>
                <div className="max-width-39-36">
                  <p>
                    The regular generation of Solana due to staking, which is
                    reinvestable or monetizable.
                  </p>
                </div>
              </div>
              <div
                id="w-node-_337209a4-90ca-0554-5d3b-2654f2b58d65-41beb241"
                className="value-component"
              >
                <div className="heading-style-h4">
                  <div className="text-weight-semibold">
                    <div>Increase in NAV</div>
                  </div>
                </div>
                <div className="max-width-39-36">
                  <p>
                    The market valuation is higher than the Net Asset Value,
                    allowing for faster fundraising to acquire more SOL and
                    increasing the NAV.
                  </p>
                </div>
              </div>
              <div
                id="w-node-_4a898e02-c24e-9861-7859-9652d585549c-41beb241"
                className="value-component"
              >
                <div className="heading-style-h4">
                  <div className="text-weight-semibold">
                    <div>SOL Appreciation</div>
                  </div>
                </div>
                <div className="max-width-39-36">
                  <p>
                    Solana remains a promising long-term investment with its
                    growing ecosystem, improving reliability, and active
                    developer base giving it strong fundamentals.
                  </p>
                </div>
              </div>
              <div
                id="w-node-_930e97f4-ca8f-5587-5de6-5d51fa888b59-41beb241"
                className="value-component"
              >
                <div className="heading-style-h4">
                  <div className="text-weight-semibold">
                    <div>Leading High-Performance Blockchain</div>
                  </div>
                </div>
                <div className="max-width-39-36">
                  <p>
                    Solana is poised to lead the next phase of decentralized
                    application adoption, driven by sustainable economics,
                    developer innovation, and execution excellence.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Advantages;